// import { isFunction, isEmpty } from '@primevue/core';
import type { AppCodeMap, AppValueOption, ClassroomStatusType } from '@/types/type';
import { useNuxtApp } from "#app";
import type { Dayjs } from "dayjs";
import * as _ from "lodash";
import { getLocalTimeZone } from "@internationalized/date";
import { parseZonedDateTime, parseDate, type DateValue } from "@internationalized/date";
import { computed, ref } from "vue";

const dayjs = useDayjs();

// export const getCodeMap = async () => {
//   await storeCodeMapRefresh();
//   const codeMapStore = useCodeMapStore();
//   return codeMapStore.getCodeMap;
// }

// export const getCodeMapByCode = async (code: string) => {
//   await storeCodeMapRefresh(code);
//   const codeMapStore = useCodeMapStore();
//   return codeMapStore.getCodeMapByCode(code);
// }

// const storeCodeMapRefresh = async (code: string) => {
//   const { $axios } = useNuxtApp();
//   const codeMapStore = useCodeMapStore();

//   if(isEmpty(codeMapStore.getCodeMap) || dayjs(dayjs()).diff(codeMapStore.getTime, 'm') > 10 || ( isNotBlank(code) && isEmpty(codeMapStore.getCodeMap[code]))) {
//     const result = await $axios.get(`/api/main/code-map`);
//     codeMapStore.setCodeMap(result);
//     codeMapStore.setTime(dayjs());
//     return;
//   }
// }

export const isNotBlank = (str: string) => {
  return str !== undefined && str !== null && String(str).trim() !== "";
};

export const isBlank = (str: string) => {
  return !isNotBlank(str);
};

export const isImage = (type: string) => {
  return type.startsWith("image");
};
export const appendFormData = (formData: any, obj: any, properties: string[]) => {
  _.chain(obj)
    .entries()
    .filter((row) => _.includes(properties, row[0]) && isNotBlank(row[1]))
    .value()
    .forEach((row) => formData.append(row[0], row[1]));
};

export const formatTextarea = (value: string) => {
  if (isBlank(value)) {
    return "";
  }
  return value.replace(/\n/g, "</p>\n<p>");
};

/**
 * DateTime 포맷팅 (YYYY.MM.DD HH:mm:ss)
 */
export const formatDateTime2 = (value: string | Date | Dayjs) => {
    return dayjsDateFormat(value, "YYYY.MM.DD HH:mm:ss");
};

/**
 * DateTime 포맷팅 (YYYY-MM-DD HH:mm:ss)
 */
export const formatDateTime = (value: string | Date | Dayjs) => {
  return dayjsDateFormat(value, "YYYY-MM-DD HH:mm:ss");
};

/**
 * Date 포맷팅 (YYYY-MM-DD)
 */
export const formatDate = (value: string | Date | Dayjs) => {
  return dayjsDateFormat(value, "YYYY-MM-DD");
};

/**
 * Date 포맷팅 (MM.DD)
 */
export const formatDate3 = (value: string | Date | Dayjs) => {
    return dayjsDateFormat(value, "MM.DD");
};

/**
 * Date 포맷팅 (YYYY-MM-DD)
 */
export const formatDate2 = (value: string | Date | Dayjs) => {
  return dayjsDateFormat(value, "YYYY.MM.DD");
};

/**
 * Date 포맷팅 (YYYY-MM-DD)
 */
export const formatDateYYYYMMDD = (value: string | Date | Dayjs) => {
  return dayjsDateFormat(value, "YYYYMMDD");
};

/**
 * Date 포맷팅 (YYYY)
 */
export const formatDateYYYY = (value: string | Date | Dayjs) => {
  return dayjsDateFormat(value, "YYYY");
};

const dayjsDateFormat = (value: string | Date | Dayjs, format: string = "YYYY-MM-DD") => {
  let toDayjs;
  if (_.isDate(value) || _.isString(value)) {
    toDayjs = dayjs(value);
  } else if (dayjs.isDayjs(value)) {
    toDayjs = value;
  } else {
    return "";
  }
  if (toDayjs.isValid()) {
    return toDayjs.format(format);
  }
  return "";
};

/** DateValue 타입 -> 'YYYY.MM.DD' 포맷팅 */
export const toYmdDotFromDateValue = (dv?: DateValue | null) => {
  let tz = getLocalTimeZone()
  if (!dv) return ''
  const d = dv.toDate(tz) // 로컬 타임존 기준 Date
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  return `${y}.${m}.${dd}`
}

export const toYmdhmsDotFromDateValue = (dv?: DateValue | null) => {
  let tz = getLocalTimeZone()
  if (!dv) return ''
  const d = dv.toDate(tz) // 로컬 타임존 기준 Date
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  return `${y}.${m}.${dd} 00:00:00`
}

/** 'YYYY.MM.DD' -> DateValue 타입 타임존 포람*/
export const dotYmdToDateValue = (s: string, timeZone = 'Asia/Seoul'): DateValue => {
  const m = s.match(/^(\d{4})\.(\d{1,2})\.(\d{1,2})$/);
  if (!m) throw new Error('형식은 YYYY.MM.DD 여야 합니다.');
  const [, y, mo, d] = m;
  const ymd = `${y}-${mo.padStart(2, '0')}-${d.padStart(2, '0')}`; // "YYYY-MM-DD"
  // ZonedDateTime 으로 파싱 (자정 00:00 고정)
  return parseZonedDateTime(`${ymd}T00:00[${timeZone}]`);
}


// export const movePosition = (el: string) => {
//     _.delay(() => {
//       const section = document.getElementById(el);

//       const sectionTop = section == null ? 0 : section.offsetTop;
//       window.scrollTo({
//         top: sectionTop,
//         behavior: "smooth"
//       });
//     }, 100)
// }

// // 셀 ROWNUM 병합
// export const mergeRowNum = (list : any[], key: string) => {
//     list.forEach((row, index, rows) => {
//       if(index === 0) {
//         row.rowNum = index + 1;
//       } else if (rows[index][key] === rows[index-1][key]) {
//         row.rowNum = rows[index-1].rowNum;
//       } else {
//         row.rowNum = index + 1;
//       }
//     })
//   }

export const getParams = (searchParams: any) => {
  const adjustSearchParams = _.pickBy(
    searchParams,
    (row: any) => _.isNumber(row) || _.isBoolean(row) || (!_.isEmpty(row) && !_.isEmpty(row.trim()))
  );
  return new URLSearchParams(adjustSearchParams).toString();
};

/** 그리드 리스트 필터 */
// export const listFilter = (list: any[], search: SearchParam, condition: SearchParam) => {
//   if(_.isEmpty(list))  {
//       return [];
//   }
//   const searchProperties = _.chain(search).omitBy(isBlank).keys().value();
//   if (_.isEmpty(searchProperties)) {
//     return list;
//   }

//   const test = list.filter(item => {
//     return searchProperties.every((fieldNm: string) => {
//       const value = item[fieldNm] ?? '';
//       switch(condition[fieldNm]) {
//         case "eq" : {
//           return value == search[fieldNm];
//         }
//         case "contains" : {
//           return value.indexOf(search[fieldNm]) > -1;
//         }
//         case "containsIgnoreCase" : {
//           return value.toLowerCase().indexOf(search[fieldNm].toLowerCase()) > -1;
//         }
//       }
//       if (isFunction(condition[fieldNm])) {
//         return condition[fieldNm](item, search[fieldNm]);
//       }
//     })
//   })

//   return test;

// }

const convertObjectToOptions = (obj: object, sortByValue: boolean | undefined) => {
  return _.reduce(
    obj,
    (acc: AppValueOption[], value: string, key: string) => {
      acc.push({ label: value, value: key });
      if (sortByValue == null || !sortByValue) {
        return _.sortBy(acc, "label");
      }
      return _.sortBy(acc, "value");
    },
    []
  );
};

const convertObjectToOptionsByNumber = (obj: object, sortByValue: Boolean) => {
  return _.reduce(
    obj,
    (acc: AppValueOption[], value: string, key: string | number) => {
      acc.push({ label: value, value: _.toNumber(key) });
      if (sortByValue == null || !sortByValue) {
        return _.sortBy(acc, "label");
      }
      return _.sortBy(acc, "value");
    },
    []
  );
};

const convertObjectToOptionsByBool = (obj: object) => {
  return _.reduce(
    obj,
    (acc: AppValueOption[], value: string, key: string | boolean) => {
      key = key === "Y" ? true : false;
      acc.push({ label: value, value: key });
      return acc;
    },
    []
  );
};

const convertObjectToOptionsWithKey = (obj: object, sortByValue: Boolean) => {
  return _.reduce(
    obj,
    (acc: AppValueOption[], value: string, key: string) => {
      acc.push({ label: key + `(${value})`, value: key });
      if (sortByValue == null || !sortByValue) {
        return _.sortBy(acc, "label");
      }
      return _.sortBy(acc, "value");
    },
    []
  );
};

const convertObjectToOptionsWithValue = (obj: object, sortByValue: Boolean) => {
  return _.reduce(
    obj,
    (acc: AppValueOption[], value: string, key: string) => {
      acc.push({ label: value + `(${key})`, value: key });
      if (sortByValue == null || !sortByValue) {
        return _.sortBy(acc, "label");
      }
      return _.sortBy(acc, "value");
    },
    []
  );
};

const convertObjectToOptionsWithCode = (obj: object, sortByValue: Boolean) => {
  return _.reduce(
    obj,
    (acc: AppValueOption[], value: string, key: string) => {
      acc.push({ label: key, value: key });
      if (sortByValue == null || !sortByValue) {
        return _.sortBy(acc, "label");
      }
      return _.sortBy(acc, "value");
    },
    []
  );
};

export const convertUtils = () => {
  return {
    convertObjectToOptions,
    convertObjectToOptionsByNumber,
    convertObjectToOptionsByBool,
    convertObjectToOptionsWithKey,
    convertObjectToOptionsWithValue,
    convertObjectToOptionsWithCode,
  };
};

export const displayCorpNo = (value: string) => {
  if (isBlank(value) || value.length != 10) {
    return value;
  }
  return value.substring(0, 3) + "-" + value.substring(3, 5) + "-" + value.substring(5, 10);
};

export const displayUtils = () => {
  return {
    displayCorpNo,
  };
};

export const addEmptyOptions = (options: any, hasEmptyOption: boolean, isSearch: boolean) => {
  options.forEach((row) => (row.label = row.name));
  if (!hasEmptyOption) {
    return options ?? [];
  }

  let defaultValue;
  if (typeof options?.at(0)?.value === "string") {
    defaultValue = "";
  }
  let emptyOption: AppValueOption[] = [
    { name: selectLable(isSearch), value: defaultValue, label: selectLable(isSearch) },
  ];

  return emptyOption.concat(options ?? []);
};

export const getClassroomStatus = (lctrYmd: string, bgngTm: string, endTm: string, tcbizYn: string) : ClassroomStatusType => {
    const startDt = dayjs(lctrYmd + ' ' + bgngTm, 'YYYY-MM-DD HH:mm:ss');
    const endDt = dayjs(lctrYmd + ' ' + endTm, 'YYYY-MM-DD HH:mm:ss');

    if(tcbizYn === 'Y') {
      return 'CANCELLED';
    } else if (dayjs().isBefore(startDt)) {
      return 'UPCOMING';
    } else if (endDt.isBefore(dayjs())) {
      return 'ENDED';
    } else {
      return 'IN_PROGRESS';
    }
}